<template>
  <button type="button" class="mbtn btn-warn">
    <span class="fas fa-filter">
      <span class="fas fa-ban"></span>
    </span>
    Clear Filter
  </button>
</template>

<style scoped>
.btn-warn .fa-filter {
  position: relative;
  font-size: 14px;
  /* margin-right: -20px; */
}

.mbtn .fa-filter .fa-ban {
  position: absolute;
  color: red;
  left: -3px;
  font-size: 10px;
  top: 0px;
}
</style>
